import type { PricingPlanCard } from '../constants/pricingPlans.constants'
import type { ConsumerProBillingInterval } from '../constants/consumerProBilling.constants'
import type { PricingCtaState } from './pricingCtaState.helper'

export interface PricingCtaPressDeps {
  onB2bCheckout: (tier: 'BUSINESS' | 'ENTERPRISE') => void
  onConsumerProCheckout: (billingInterval: ConsumerProBillingInterval) => void
  onSignIn: () => void
  onContinueToApp: () => void
  onContactSales: () => void
  onCreateOrg: () => void
  onManageConsumerSubscription: () => void
  onManageB2bBilling: () => void
  onScheduleDowngradeToMonthly: () => void
}

/**
 * Runs the primary CTA for a pricing card (shared by /packs and landing).
 */
export function invokePricingCtaAction(
  plan: PricingPlanCard,
  state: PricingCtaState,
  deps: PricingCtaPressDeps,
): void {
  switch (state.action) {
    case 'checkout':
      deps.onB2bCheckout(plan.tier as 'BUSINESS' | 'ENTERPRISE')
      return
    case 'consumer-checkout': {
      const interval = plan.consumerProBillingInterval
      if (interval != null) {
        deps.onConsumerProCheckout(interval)
      }
      return
    }
    case 'sign-in':
      deps.onSignIn()
      return
    case 'continue-app':
      deps.onContinueToApp()
      return
    case 'contact':
      deps.onContactSales()
      return
    case 'create-org':
      deps.onCreateOrg()
      return
    case 'coming-soon':
      // Coming-soon CTA renders disabled; nothing to invoke.
      return
    case 'manage-consumer-billing':
      deps.onManageConsumerSubscription()
      return
    case 'manage-b2b-billing':
      deps.onManageB2bBilling()
      return
    case 'schedule-downgrade-to-monthly':
      deps.onScheduleDowngradeToMonthly()
      return
    default:
      return
  }
}
